/**
 * 主站组织代登权限校验（与 server-core/partner/permissions 对齐）
 */

const LEGACY_EXPAND: Record<string, string[]> = {
  'shop.config': ['shop.config.view', 'shop.config.manage'],
}

const VIEW_BY_MANAGE: Record<string, string> = {
  'shop.config.view': 'shop.config.manage',
  'campaign.view': 'campaign.manage',
  'algorithm.view': 'algorithm.manage',
  'auto_placement.view': 'auto_placement.manage',
  'product.view': 'product.manage',
  'rpa.view': 'rpa.manage',
  'invalid_campaign.view': 'invalid_campaign.manage',
  'package.view': 'package.manage',
  'message.view': 'message.manage',
}

/** 勾选 manage 时自动勾选 view */
export const MANAGE_REQUIRES_VIEW: Record<string, string> = {
  'shop.config.manage': 'shop.config.view',
  'campaign.manage': 'campaign.view',
  'algorithm.manage': 'algorithm.view',
  'auto_placement.manage': 'auto_placement.view',
  'product.manage': 'product.view',
  'rpa.manage': 'rpa.view',
  'invalid_campaign.manage': 'invalid_campaign.view',
  'package.manage': 'package.view',
  'message.manage': 'message.view',
}

export function normalizeOrgPermissions(input: string[] | undefined | null): string[] {
  if (!input?.length) return []
  const set = new Set<string>()
  for (const item of input) {
    const k = String(item)
    const expanded = LEGACY_EXPAND[k]
    if (expanded) {
      for (const e of expanded) set.add(e)
      continue
    }
    set.add(k)
  }
  // 有写必有读：补齐缺失的 view
  for (const [manage, view] of Object.entries(MANAGE_REQUIRES_VIEW)) {
    if (set.has(manage)) set.add(view)
  }
  return [...set]
}

export function hasOrgPermission(granted: string[] | undefined | null, required: string): boolean {
  const normalized = normalizeOrgPermissions(granted)
  if (normalized.includes(required)) return true
  const legacy = LEGACY_EXPAND[required]
  if (legacy) return legacy.every((k) => hasOrgPermission(normalized, k))
  const manage = VIEW_BY_MANAGE[required]
  if (manage && normalized.includes(manage)) return true
  return false
}

export function hasAnyOrgPermission(
  granted: string[] | undefined | null,
  required: string[]
): boolean {
  return required.some((r) => hasOrgPermission(granted, r))
}

/** 勾选变更：改 manage → 补 view；取消 view → 去掉对应 manage */
export function applyPermissionSelection(
  current: string[],
  next: string[],
  allKeys: string[]
): string[] {
  const cur = new Set(current)
  const nxt = new Set(next)
  const added = [...nxt].filter((k) => !cur.has(k))
  const removed = [...cur].filter((k) => !nxt.has(k))

  for (const k of added) {
    const view = MANAGE_REQUIRES_VIEW[k]
    if (view && allKeys.includes(view)) nxt.add(view)
  }
  for (const k of removed) {
    for (const [manage, view] of Object.entries(MANAGE_REQUIRES_VIEW)) {
      if (view === k) nxt.delete(manage)
    }
  }
  return [...nxt]
}
